var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D75B1865-3F34-4762-A43E-FC74DB2DC15B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF1-MOBILE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Mobile",
    transform: "translate(-332.000000, -27.000000)",
    fill: "#777E90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Menu",
    transform: "translate(327.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70710683,5.29289341 L12,10.5857868 L17.2928934,5.29289323 C17.6834173,4.9023689 18.3165827,4.9023689 18.7071066,5.29289323 C19.097631,5.6834175 19.097631,6.31658256 18.7071066,6.70710683 L13.4142132,12 L18.7071066,17.2928934 C19.097631,17.6834173 19.097631,18.3165827 18.7071066,18.7071066 C18.3165827,19.097631 17.6834173,19.097631 17.2928934,18.7071066 L12,13.4142132 L6.70710707,18.7071066 C6.3165828,19.097631 5.68341768,19.097631 5.29289341,18.7071066 C4.90236908,18.3165827 4.90236908,17.6834173 5.29289341,17.2928934 L10.5857868,12 L5.29289323,6.70710707 C4.9023689,6.3165828 4.9023689,5.68341768 5.29289323,5.29289341 C5.6834175,4.90236908 6.31658256,4.90236908 6.70710683,5.29289341 Z",
    id: "Close-icon"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9b653b8a98d893977ff0b65604f8ee04.svg";
export { ForwardRef as ReactComponent };